angular.module("rental")
    .component('rentalAgreementBtnOptions', {
        bindings: {
            item: '=',
            largeButton: '='
        },
        templateUrl: 'app/rental/agreement/_btn-options.html',
        controller: function (RentalAgreementService, FilesLibrary, FilesSimpleUploadService, Principal, RentalAgreementConst) {
            this.RentalAgreementService = RentalAgreementService;
            this.FilesLibrary = FilesLibrary;
            this.FilesSimpleUploadService = FilesSimpleUploadService;

            this.fileResourceName = "RENTAL-AGREEMENT"

            this.$onInit = () => {
                this.canRead = Principal.hasAnyAuthority([RentalAgreementConst.RoleAgreementRead])
                this.canWrite = Principal.hasAnyAuthority([RentalAgreementConst.RoleAgreementWrite])
            }

            this.canEdit = () => {
                return this.canWrite
            }

            this.canDelete = () => {
                return this.canWrite
            }
        }
    })
